import React from 'react'
import styled from 'styled-components'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'

interface DefaultFooterProps {
  className?: string
  extraContent?: React.ReactNode
}

const FooterWrapper = styled.footer`
  width: 100%;
  font-size: 0.8125rem;
  padding: 48px 16px 16px;
  transition: all
    ${({ theme }) =>
      `${theme.transitions.duration[2]} ${theme.transitions.timing.easeOut}`};

  ul {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0;
    padding: 0;
    list-style: none;
    flex-wrap: wrap;
  }

  li {
    margin: 8px 12px;
  }

  a,
  span {
    transition: color ${({ theme }) => theme.transitions.duration[1]};
    white-space: nowrap;
    text-decoration: none;

    color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  }

  li a:hover,
  li span:hover {
    cursor: pointer;
    color: rgba(36, 36, 36, 0.5);
  }
`

const Footer: React.FC<DefaultFooterProps> = ({ className, extraContent }) => (
  <FooterWrapper className={className}>
    <ul>
      <li>
        <a
          href={`${SKETCH_WEBSITE}/tos`}
          target="_blank"
          rel="noopener noreferrer">
          Terms of Service
        </a>
      </li>
      <li>
        <a
          href={`${SKETCH_WEBSITE}/support/contact/`}
          target="_blank"
          rel="noopener noreferrer">
          Support
        </a>
      </li>
      {extraContent}
      <li>
        <a href={`${SKETCH_WEBSITE}`} target="_blank" rel="noopener noreferrer">
          © {new Date().getFullYear()} Sketch B.V.
        </a>
      </li>
    </ul>
  </FooterWrapper>
)

export default Footer
